import React from 'react';
import { Flex } from '@atlaskit/primitives/compiled';
import ChangesIcon from '@atlaskit/icon/core/changes';
import { IssueTypeIcon } from '@atlassian/jira-polaris-component-issue-types/src/ui/issue-type-icon/issue-type-icon.tsx';
import {
	isIssueTypeNameFilter,
	type ConnectionFieldIssueTypeFilter,
} from '@atlassian/jira-polaris-domain-field/src/field/connection/types.tsx';
import { useIssueTypeByNameAndProjectIds } from '@atlassian/jira-polaris-component-issue-types/src/controllers/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

type Props = {
	issueTypeFilters?: ConnectionFieldIssueTypeFilter[];
};

export const ConnectionFieldIcon = ({ issueTypeFilters = [] }: Props) => {
	const { formatMessage } = useIntl();
	const issueTypeNameFilter = issueTypeFilters.find(isIssueTypeNameFilter);
	const issueTypeByName = useIssueTypeByNameAndProjectIds({
		name: issueTypeNameFilter?.names[0],
		projectIds: issueTypeNameFilter?.projectIds,
	});

	if (issueTypeByName) {
		return (
			<Flex alignItems="center">
				<IssueTypeIcon issueTypeId={issueTypeByName.id} />
			</Flex>
		);
	}

	return <ChangesIcon label={formatMessage(messages.connection)} color="var(--ds-icon)" />;
};
